// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homeButton{background:#c33d2b;color:#fff;padding:25px 5px 25px 25px;position:fixed;top:0;left:0;transform:rotate(45deg) translate(-30px, -7px);transition:all 500ms;z-index:50}.homeButton.hidden{transform:rotate(45deg) translate(-63px, -10px)}.homeButton svg{transform:rotate(-45deg)}", ""]);
// Exports
module.exports = exports;
